var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_2515_5650)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.9707 6.5C6.76635 6.5 7.52941 6.18393 8.09202 5.62132C8.65463 5.05871 8.9707 4.29565 8.9707 3.5C8.9707 2.70435 8.65463 1.94129 8.09202 1.37868C7.52941 0.816071 6.76635 0.5 5.9707 0.5C5.17505 0.5 4.41199 0.816071 3.84938 1.37868C3.28677 1.94129 2.9707 2.70435 2.9707 3.5C2.9707 4.29565 3.28677 5.05871 3.84938 5.62132C4.41199 6.18393 5.17505 6.5 5.9707 6.5ZM4.89961 7.625C2.59102 7.625 0.720703 9.49531 0.720703 11.8039C0.720703 12.1883 1.03242 12.5 1.4168 12.5H10.5246C10.909 12.5 11.2207 12.1883 11.2207 11.8039C11.2207 9.49531 9.35039 7.625 7.0418 7.625H4.89961Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2515_5650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.0704e38c20014190891572f879497257.svg";
export { ForwardRef as ReactComponent };